import { createFormatForDescription as cffd } from '../createFormatForDescription'
import Memo from '../types/util/Memo'

import { Explanation, explainOptional } from './Explanation'
/**
 * Explains the contents of a memo.
 *
 * @property memoData - An explanation of the memo data.
 * @property memoFormat - An explanation of the memo format.
 * @property memoType - An explanation of the memo type.
 */

export interface MemoExplanation {
  readonly memoData?: Explanation<string>
  readonly memoFormat?: Explanation<string>
  readonly memoType?: Explanation<string>
}

/**
 * Creates an explanation of a single memo.
 *
 * @param memo - The memo to be explained.
 * @returns An explanation of the memo.
 */
export function createMemoExplanation(memo: Memo): MemoExplanation {
  // TODO: Add support for some memo formats and perhaps decode some of the data.
  const memoData = explainOptional(
    memo.Memo.MemoData,
    (data) => `The main memo data was ${cffd(data, 'data')}`,
  )

  const memoFormat = explainOptional(
    memo.Memo.MemoFormat,
    (format) => `The format of the memo was ${cffd(format, 'format')}`,
  )

  const memoType = explainOptional(
    memo.Memo.MemoType,
    (type) => `The type of the memo was ${cffd(type, 'type')}`,
  )

  return {
    ...(memoData && { memoData }),
    ...(memoFormat && { memoFormat }),
    ...(memoType && { memoType }),
  }
}
